'use client';

import { useCallback } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { alert } from '@flipster/ui/Alert';
import { getUserAgentInfo } from '@flipster/utils/user-agent';

import { useGetUrlWithAnonymousId } from '../hooks/useGetUrlWithAnonymousId';
import { FlipsterIcon } from '../logo';

export const useShowAppDownloadAlert = () => {
  const getUrlWithAnonymousId = useGetUrlWithAnonymousId();

  return useCallback(() => {
    return alert.show({
      message: (
        <div className={vstack({ textAlign: 'center' })}>
          <FlipsterIcon type='rounded' color='blue' size='small' css={{ mb: 12 }} />
          <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5', mb: 4 })}>
            <FormattedMessage id='Autogen_common.r251126.s_Start_trading_on_Flipster' />
          </p>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Install_the_Flipster_app_to_start_trading_and_climb_the_leaderboard' />
          </p>
        </div>
      ),
      confirmText: <FormattedMessage id='Common.r251104.Download_app' />,
      closeText: <FormattedMessage id='Common.r251008.Not_now' />,
      onConfirm: () => {
        const path = getUserAgentInfo().isAndroid
          ? getUrlWithAnonymousId('PlaystoreDownload')
          : getUrlWithAnonymousId('Download');
        window.location.href = path;
      },
      withClose: true,
    });
  }, [getUrlWithAnonymousId]);
};
